import React from "react";

import { Tabs, Button, message } from "antd";
import { useDispatch, useSelector } from "react-redux";
import PageHeader from "../../PageHeader";
import {
  advanceApproval,
  updateAdvanceApproval,
  getRoles,
  UpdateAdvanceApproval,
} from "../../../actions/companySettings";
import { hasAccess, objectToFormData } from "../../../utils";
import "./../styles/setting.css";
import HirarchicalApproval from "./HirarchicalApproval";

const { TabPane } = Tabs;

message.config({
  maxCount: 3,
});

const ApprovalAdvance = () => {
  const dispatch = useDispatch();
  const [advanceApprovalData, setAdvanceApprovalData] = React.useState([]);
  const [rolesData, setRolesData] = React.useState([]);
  const [selectedRoles, setSelectedRoles] = React.useState([]);
  const advanceApprovalResponse = useSelector(
    (state) => state.companySetting.advanceApproval || {},
  );
  const updateAdvanceApprovalResponse = useSelector(
    (state) => state.companySetting.updateAdvanceApproval || {},
  );
  const rolesResponse = useSelector(
    (state) => state.companySetting.getRoles || {},
  );
  const [editMode, setEditMode] = React.useState(false);

  const setTab = () => {};

  React.useEffect(() => {
    dispatch(advanceApproval({}));
    dispatch(getRoles({}));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    const {
      data: { response: { advance_approvals = [] } = {}, status = false } = {},
    } = advanceApprovalResponse;
    if (status && advance_approvals) {
      setAdvanceApprovalData(
        advance_approvals?.map((ele, idx) => ({ ...ele, level: idx })),
      );
      setSelectedRoles(advance_approvals.map((k) => k.role_id));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [advanceApprovalResponse]);

  React.useEffect(() => {
    const {
      data: {
        response: { advance_approvals = [] } = {},
        status = "",
        message: res_message = "",
        errors = "",
      } = {},
    } = updateAdvanceApprovalResponse;
    if (status && advance_approvals) {
      setAdvanceApprovalData(
        advance_approvals?.map((ele, idx) => ({ ...ele, level: idx })),
      );
      setSelectedRoles(advance_approvals.map((k) => k.role_id));
      setEditMode(false);
      dispatch({
        type: UpdateAdvanceApproval.RESET,
      });
    } else if (status === false) {
      dispatch({
        type: UpdateAdvanceApproval.RESET,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateAdvanceApprovalResponse]);

  React.useEffect(() => {
    const { data: { response: { roles = {} } = {}, status = false } = {} } =
      rolesResponse;
    if (status) {
      setRolesData(roles);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rolesResponse]);

  const handleSubmit = () => {
    const dataArray = advanceApprovalData.map(
      ({ role_name, id, ...rest }) => rest,
    );
    dispatch(
      updateAdvanceApproval(
        objectToFormData({ advance_approvals: [...dataArray] }),
      ),
    );
  };

  const handleCancel = () => {
    setEditMode(false);
    const filterArray = advanceApprovalData[advanceApprovalData.length - 1];
    if (!filterArray?.role_id) {
      advanceApprovalData.splice(advanceApprovalData.length - 1);
      setAdvanceApprovalData([...advanceApprovalData]);
    }
  };

  const handleApproveList = (type, key) => {
    if (type === "add") {
      setAdvanceApprovalData([
        ...advanceApprovalData,
        {
          can_approve_or_reject: false,
          // can_reimburse: false,
          id: advanceApprovalData.length,
          level: advanceApprovalData.length,
          role_id: "",
        },
      ]);
    } else {
      const filterArray = advanceApprovalData.filter(
        (obj) => obj.level !== key,
      );
      const updatedArray = filterArray.map(({ level, ...rest }, index) => {
        return { level: index, ...rest };
      });
      setAdvanceApprovalData([...updatedArray]);
    }
  };

  return (
    <>
      <div className="heading-div">
        <PageHeader
          title={`Advance Approval`}
          navigation={{
            Home: "/dashboard/",
            "Advance Approval": null,
          }}
        />
      </div>
      <Tabs onChange={setTab} type="card" size="large" className="custom-tabs">
        <TabPane tab="Hierarchical Approvals" key="preferences">
          <div className="tabContentWrapper">
            <HirarchicalApproval
              approvalData={advanceApprovalData}
              setApprovalData={setAdvanceApprovalData}
              editMode={editMode}
              handleList={handleApproveList}
              selectedRoles={selectedRoles}
              setSelectedRoles={setSelectedRoles}
              rolesData={rolesData}
            />
            {editMode && (
              <Button
                type="default"
                disabled={!editMode}
                ghost
                className="approve-add-btn mt1"
                onClick={() => handleApproveList("add")}
              >
                + Add one more
              </Button>
            )}
            <div className="floatBottom">
              {!editMode && hasAccess("approvals", "write") && (
                <Button
                  className="formButton mt1 primaryButton"
                  onClick={() => setEditMode(true)}
                >
                  Edit
                </Button>
              )}
              {editMode && (
                <>
                  <Button
                    key="1"
                    className="formButton mt1 primaryButton"
                    onClick={() => handleSubmit()}
                  >
                    Save
                  </Button>
                  <Button
                    key="2"
                    className="cancelButton ml1 mt1"
                    onClick={() => handleCancel()}
                  >
                    Cancel
                  </Button>
                </>
              )}
            </div>
          </div>
        </TabPane>
      </Tabs>
    </>
  );
};

export default ApprovalAdvance;
